export default __webpack_public_path__ + "static/finding-uid-android-c7b2a86c423cd97f4423e56cc9036512.gif";